import { InfoCustomerServiceAction } from "Components/InfoCustomerService/Redux/actions";

export interface IInfoCustomerService {
  isFetching: boolean;
  isFetchFailed: boolean;
  content: Julius.Website.ServicePageViewModel;
};

const initialInfoCustomerService: IInfoCustomerService = {
  isFetching: false,
  isFetchFailed: false,
  content: null,
};

function infoCustomerService(
  state: IInfoCustomerService = initialInfoCustomerService, 
  action: InfoCustomerServiceAction,
  ): IInfoCustomerService {
    
  switch (action.type) {
    case 'SET_IS_FETCHING_CUSTOMERSERVICE_CONTENT':
      return {
        ...state,
        isFetching: true,
        isFetchFailed: false,
      };

    case 'SET_FETCH_CUSTOMERSERVICE_CONTENT_FAILED':
      return {
        ...state,
        isFetching: false,
        isFetchFailed: true,
      };

    case 'SET_CUSTOMERSERVICE_CONTENT':
      return {
        ...state,
        content: action.content,
        isFetching: false,
        isFetchFailed: false,
      };

    default:
      return state;
  }
}

export default infoCustomerService;


// WEBPACK FOOTER //
// ./src/components/InfoCustomerService/Redux/reducer.tsx